import { NgModule } from '@angular/core';
import { CmsConfig, RoutingConfig, provideConfig, provideDefaultConfigFactory } from '@spartacus/core';
import { PRODUCT_FEATURE } from './feature-name';

// TODO: Inline this factory when we start releasing Ivy compiled libraries
export function knbrProductComponentsConfig(): CmsConfig {
  const config: CmsConfig = {
    featureModules: {
      [PRODUCT_FEATURE]: {
        cmsComponents: [
          'ProductRefinementComponent',
          'KnBrProductActionBarComponent',
          'KnBrProductIntroComponent',
          'KnBrProductImagesComponent',
          'KnBrProductSummaryComponent',
          'SearchBoxComponent',
          'CMSProductListComponent',
          'ProductGridComponent',
          'SearchResultsListComponent',
          'KnBrQuoteReferenceComponent',
        ],
      },
    },
  };

  return config;
}

@NgModule({
  imports: [],
  providers: [
    provideDefaultConfigFactory(knbrProductComponentsConfig),
    provideConfig(<RoutingConfig>{
      routing: {
        routes: {
          category: {
            paths: ['c/:categoryCode', 'category/:categoryCode', ':category/c/:categoryCode'],
            paramsMapping: { categoryCode: 'code' },
          },
          product: {
            paths: ['product/:productCode/:prettyName', 'product/:productCode/:name'],
          },
        },
      },
    }),
  ],
})
export class ProductRootModule { }
